/* eslint-disable max-len */
import styled from 'styled-components';
import {
  Row, Col, Button, Tooltip,
  Input,
} from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { usePrevious } from 'Utils/hooks/usePrevious';
import CompanySkeleton from 'Components/common/skeleton/CompanySkeleton';
import {
  maxMobile,
  maxTablet,
  maxWidth, midWidthApp, minWidthApp, primaryColor, primaryFont, retina, retinaOne, secondaryFont,
  smMobile,
  wLight,
} from 'Utils/utilsStyle';
import {
  IsMobile,
  IsTablet, MinWidthApp, formatNumberWithCommas, getFlurrySortingType, setLocalStorageValue, validateSearchQuery, valueToObject,
} from 'Utils/UtilityFunctions';
import { useNavigate } from 'react-router-dom';
import {
  COMPARE_COMPANY_ROUTE, FILE_DOWNLOAD_FAIL, FILE_DOWNLOAD_SUCCESS, ONBOARDING_ROUTE, SEARCH_ROUTE, TOOLTIP_MYACCOUNTS,
  translateSkipAreas,
} from 'Utils/Constants';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import Cross from 'Components/globalSearch/assets/Cross';
import GlobalButton from 'Components/common/components/GlobalButton';
import ExportIcon from 'Components/common/assets/svgIcons/ExportIcon';
import { actions as helperActions, actions as flurryActions } from 'Slice/HelperSlice';
import CompanyCompareIcon from 'Components/common/assets/svgIcons/CompanyCompareIcon';
import {
  selectCompanyDetailFlurry, selectCompanyDetailsCall,
  selectedCompareCompaniesIds,
  selectedSortingType,
} from 'Selector/CompaniesSelector';
import FilterCompanySortBy from 'Components/common/components/FilterCompanySortBy';
import SelectIcon from 'Components/common/assets/svgIcons/SelectIcon';
import classNames from 'classnames';
import CompanyCardLarge from '../../common/components/CompanyCardLarge';
import BinIcon from '../svgIcons/BinIcon';
import {
  selectCompanies, selectCompaniesLoading, selectCompaniesEnded,
  selectCompanyCount, selectCompaniesExportLoading,
  selectCompaniesExportUrl,
} from '../../../Selector/CompaniesSelector';
import { Company } from '../../../Types/CompaniesTypes';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';

const StyleWrapper = styled.div<{ companiesEnded: boolean, }>`
  .fancy-box {
    border-radius: 22px;
    background: rgb(255, 255, 255);
    padding: 40px 50px 40px 50px;
    margin-top: 50px;
    margin-bottom: ${(props) => (props.companiesEnded ? '0' : '10px')};
    @media all and (max-width: ${maxWidth}) , ${retina} {
     padding: 17px 25px 25px 25px;
    }
    @media all and (max-width: ${maxWidth}) , ${retinaOne} {
     padding: 17px 25px 25px 25px;
    }
    @media all and (max-width: ${maxMobile}) {
     padding: 17px 16px 16px 16px;
    }
    h1 {
      font-family: ${secondaryFont};
      color: #424b50;
      font-size: 28px;
      margin-bottom: 0;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 19px;
      }
    }
    p {
      font-family: "Roboto";
      color: #5e7079;
    }
    input {
      font-size: 16px;
      padding: 7px 12px;
    }
    label {
      font-size: 12px;
    }
    .companiesSection {
      .infinite-for-company-section {
        padding-right: 5px;
      }
      .Grid-width-row {
        margin-top: 13px !important;
        padding-right: 1px;
      }
    }
    .Grid-width-row {
      .ant-col {
        &.noSpace {
          flex: 0 0 100% !important;
          max-width: 100% !important;
        }
      }
    }
    .company-item {
      margin-bottom: 24px;
    }
    .tabs-wrapper {
      margin-right: 5px;
      .unFollowBtn {
        gap: 0px;
        padding: 7px 11px;
      }
      @media all and (max-width: ${minWidthApp}) {
        .icon-button {
          padding: 7px;
          &:nth-child(1) {
            margin-right: 3px !important;
            display: inline-block;
          }
          svg {
            height: 18px;
            path {
              fill: #7E7E7E;
            }
          }
        }
      }
      .tabs-item {
        &.select-btn, &.cancel-btn , &.share-button{
         border: 1px solid rgb(218, 218, 218) !important
        }
      }
    }
  }
  .reverse-in-sm {
    @media all and (max-width: ${maxMobile}) {
      flex-direction: column;
      align-items: flex-start;
    }
    .second-side {
      @media all and (max-width: ${maxMobile}) {
        width: 100%;
        justify-content: flex-end;
        margin-top: 10px;
      }
    }
  }
  .heading-row {
    padding: 0px 4px 0px 10px;
    @media all and (max-width: ${maxMobile}) {
      flex-direction: column;
    }
    > div {
        @media all and (max-width: ${maxMobile}) {
         width: 100%;
        }
      &.second-side {
        @media all and (max-width: ${maxMobile}) {
          justify-content: flex-end;
          margin-top: 20px;
        }
        @media all and (max-width: ${maxTablet}) {
          .tabs-wrapper {
            .icon-mode-tablet{
              padding: 5px 10px;
              svg {
                min-height: 19px;
                path {
                  fill: #7E7E7E;
                }
              }
            }
          }
        }
      }
    }
  }
  .export-company {
    .export_btn {
      &:hover {
        border: 1px solid ${primaryColor};
        color: ${primaryColor}; 
        svg {
          path {
            fill: ${primaryColor}; 
          }
        }
      }
      svg {
        margin-right: 10px;
        width: 17px;
        min-width: 17px;
        @media all and (max-width: ${maxWidth}) ,${retina} {
          width: 11px;
          min-width: 11px;
        }
      }
    }
    @media all and (max-width: ${minWidthApp}){ 
      width: 30px;
      margin-right: 15px;
      .export_btn {
        width: 33px;
        height: 32px;
        padding: 10px;
        svg {
          width: 14px;
          min-width: 14px;
        }
      }
    }
  }
  .compareBtn {
    button {
      @media all and (max-width: ${minWidthApp}){ 
        width: 100%;
        margin-left: 0px;
        padding: 5px;
      }
      svg {
        margin-right: 5px;
        @media all and (max-width: ${maxTablet}){ 
          margin-right: 10px;
        }
      }
    }
  }
  .search-bar-wrapper {
    position: relative;
    .cross-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    cursor: pointer;
    transform: translateY(-50%);
    z-index: 1;
   }
  }
  .searchBar-style {
   width: 246px;
   height: 33px;
   border-radius: 6px;
   border: 0.8px solid #D9D9D9;
   background: #FFF;
   margin-right: 8px;
   box-shadow: none !important;
   padding-right: 30px;
   height: 39px;
   margin-right: 0px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      height: 33px;
    }
    @media all and (max-width: ${midWidthApp}) {
     width: 200px;
    }
    @media all and (max-width: ${smMobile}) {
     width: 100px;
    }
    @media all and (max-width: ${maxTablet}) {
      margin-right: 8px;
    }
   &::placeholder {
    font-family: ${primaryFont};
    font-size: 14px;
    line-height: 16px;
    color: #C1C1C1;
    font-style: italic;
    font-weight: ${wLight};
   }
   &:focus {
   border: 0.8px solid ${primaryColor};
   }
  }
`;

const CompaniesSection = function CompaniesSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [editClicked, setEditClicked] = useState(false);
  const [removeClicked, setRemoveClicked] = useState(false);
  const [removedCompanies, setRemovedCompanies] = useState<number[]>([]);
  const companies: Company[] = useSelector(selectCompanies);
  const exportLoading: boolean = useSelector(selectCompaniesExportLoading);
  const companiesExportUrl: string = useSelector(selectCompaniesExportUrl);
  const loading: boolean = useSelector(selectCompaniesLoading);
  const companiesEnded: boolean = useSelector(selectCompaniesEnded);
  const previousCompanies = usePrevious(companies);
  const companiesCount = useSelector(selectCompanyCount);
  const isTab = IsTablet();
  const isMinWidth = MinWidthApp();
  const flurryObject = useSelector(selectCompanyDetailFlurry);
  const isCalled = useSelector(selectCompanyDetailsCall);
  const sortingType = useSelector(selectedSortingType);
  const selectedCompareCompanies = useSelector(selectedCompareCompaniesIds);
  const formattedCompaniesCount = formatNumberWithCommas(companiesCount);
  const [value, setValue] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const isMobile = IsMobile();
  const goBackToCompanies = (e: any) => {
    setValue('');
    e.stopPropagation();
    setSearchTerm('');
  };

  useEffect(() => {
    dispatch(companiesActions.getCompanies({
      offset: 0,
      searchTerm,
      sortingType: sortingType || 'dateFollowed:desc',
      myAccounts: true,
    }));
  }, [searchTerm]);

  const handleSearch = (keyword: string) => {
    if (keyword.length) {
      const searchQuery = validateSearchQuery(keyword.trim());
      setSearchTerm(searchQuery);
      if (searchQuery.length === 0) {
        //
      }
    } else {
      setSearchTerm('');
    }
  };

  const sendSearchQuery = (e: { key: string; }) => {
    if (e.key === 'Enter') {
      handleSearch(value);
    }
  };

  const fetchMoreCompanies = () => {
    dispatch(companiesActions.getCompanies({
      offset: companies.length,
      sortingType: sortingType || 'dateFollowed:desc',
      ...(searchTerm && { searchTerm }),
      myAccounts: true,
    }));
  };

  useEffect(() => {
    if (editClicked && companies?.length !== previousCompanies?.length) {
      setRemoveClicked(false);
      setEditClicked(false);
      setRemovedCompanies([]);
      if (companies.length < 12) {
        fetchMoreCompanies();
      }
    }
  }, [companies, sortingType]);

  const getFlurryEvent = (type: string) => {
    const label = getFlurrySortingType(type);
    return label;
  };

  useEffect(() => {
    if (sortingType !== '') {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject(getFlurryEvent(sortingType), 0),
      ));
      if (previousCompanies && previousCompanies.length > 12) {
        fetchMoreCompanies();
      }
    }
  }, [sortingType]);

  const removeSelectedCompanies = () => {
    setRemoveClicked(true);
    if (companies.length > 0) {
      let ids = '';
      let companyRemoved = '';
      for (let i = 0; i < removedCompanies.length; i += 1) {
        ids += `${i !== 0 ? ',' : ''} ${removedCompanies[i]}`;
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        companyRemoved += `${i !== 0 ? ',' : ''} ${companies.find((item) => item.companyId === removedCompanies[i])?.companyName}`;
      }
      dispatch(companiesActions.unFollowCompanies({ companyId: `${ids}`, companyRemoved }));
    }
  };

  const getButtonLabel = () => {
    if (editClicked) {
      if (removeClicked) return 'Unfollow';
      return 'Unfollow';
    }
    return 'Select';
  };

  const getCompaniesLoadingSkeleton = () => {
    const skeletons = [];
    for (let i = 0; i < 12; i += 1) {
      skeletons.push(
        <Col span={4} className="gutter-row"><CompanySkeleton /></Col>,
      );
    }
    return (
      <Row gutter={[24, 24]} className="Grid-width-row lastTwoRemove">
        {skeletons}
      </Row>
    );
  };
  const handleExport = () => {
    setEditClicked(false);
    setRemovedCompanies([]);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('click_exportButton_companyDashboard', 0),
    ));
    dispatch(companiesActions.resetCompareCompaniesIds());
    dispatch(companiesActions.getExportCompanies({
      selectedIds: selectedCompareCompanies,
      sortingType: sortingType || 'dateFollowed:desc',
      ...(searchTerm && { searchTerm }),
    }));
  };
  useEffect(() => {
    if (companiesExportUrl !== '') {
      const newWin = window.open(companiesExportUrl, '_blank');
      if (newWin) {
        dispatch(helperActions.setNotification({
          message: FILE_DOWNLOAD_SUCCESS,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
        }));
      } else {
        dispatch(helperActions.setNotification({
          message: FILE_DOWNLOAD_FAIL,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
      }
      dispatch(companiesActions.setExportCompanies(''));
    }
  }, [companiesExportUrl]);


  useEffect(() => {
    if (companiesEnded && !companies.length && !loading && searchTerm.length === 0) {
      dispatch(companiesActions.resetCompaniesData({}));
      dispatch(companiesActions.resetRecommendedCompaniesData({}));

      setLocalStorageValue('skipOnBoarding', '0');
      navigate(ONBOARDING_ROUTE);
    }
  }, [companiesEnded, companies.length, loading]);

  const onCompareSelectionToggle = useCallback((companyId: number, select: boolean) => {
    if (removeClicked) return;
    if (select) {
      dispatch(companiesActions.selectedCompareCompaniesIds(companyId));
      setRemovedCompanies((prev) => (prev.indexOf(companyId) === -1 ? [...prev, companyId] : prev));
    } else {
      setRemovedCompanies((prev) => {
        const i = prev.indexOf(companyId);
        if (i === -1) return prev;
        const next = [...prev];
        next.splice(i, 1);
        return next;
      });
      dispatch(companiesActions.removeCompareCompaniesIds(companyId));
    }
  }, [removeClicked, dispatch]);

  const selectHandler = () => {
    if (editClicked) {
      dispatch(companiesActions.resetCompareCompaniesIds());
      removeSelectedCompanies();
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('click_unfollowButton_companyDashboard', 0),
      ));
    } else {
      setEditClicked(!editClicked);
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('click_selectButton_companyDashboard', 0),
      ));
    }
  };

  const searchQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    if (e.target.value.length === 0) {
      setSearchTerm('');
    }
    e.stopPropagation();
  };

  const goOnGlobalSearch = () => {
    const path = `${SEARCH_ROUTE}${searchTerm}`;
    const currentPath = location.pathname + location.search;
    navigate(path, {
      state: {
        enableBackButton: true,
        query: searchTerm,
        previousPath: currentPath,
      },
    });
  };

  return (
    <StyleWrapper companiesEnded={companiesEnded}>
      <div className="fancy-box">
        <div className="d-flex justify-content-between align-items-center reverse-in-sm mb-50">
          <div className="d-flex align-items-center">
            <h1 className="d-flex align-items-center">
              My Accounts
              <span className={` ml-c-5 ${translateSkipAreas}`}>
                (
                {searchTerm.length ? companies.length : formattedCompaniesCount}
                )
              </span>
              <HeadingWithToolTip
                toolTipText={TOOLTIP_MYACCOUNTS}
              />

            </h1>
          </div>
          <div className="d-flex align-items-center second-side">
            <div className="search-bar-wrapper">
              <Input
                placeholder="Search company you follow"
                value={value}
                onChange={searchQueryChange}
                onPressEnter={sendSearchQuery}
                className="searchBar-style"
              />
              {value.length > 0 && (
                <Cross
                  className="cross-icon"
                  onClick={(e: any) => { goBackToCompanies(e); }}
                />
              )}
            </div>
            <div className={classNames('tabs-wrapper  staff-btn-style d-flex align-items-center', { disabled: companies?.length === 0 })}>
              <div className="export-company compareBtn">
                <GlobalButton
                  title="Compare"
                  textColor="#fff"
                  outlineColor="#1EC252"
                  bgColor="#1EC252"
                  LeftSpace="12px"
                  RightSpace="12px"
                  PaddingSm="5px 10px"
                  innerSpace="9px 10px"
                  IconLeft={<CompanyCompareIcon color="#fff" />}
                  onButtonClick={() => {
                    dispatch(flurryActions.callFlurryEvent(
                      valueToObject('click_compareCompanies_companyDashboard', 0, {
                        ...flurryObject,
                        ...isCalled && { isCalled },
                      }),
                    ));
                    navigate(COMPARE_COMPANY_ROUTE);
                  }}
                  inCompanyCompare
                />
              </div>
              <FilterCompanySortBy
                buttonHeight="38px"
                buttonHeightSm="32px"
                iconModeBtnWidth="38px"
                iconModeFlag={isMinWidth}
                setEditClicked={() => setEditClicked(true)}
                setRemovedCompanies={() => setRemovedCompanies([])}
              />
              <Button
                className={classNames(
                  'tabs-item select-btn icon-button icon-mode-tablet d-flex justify-content-center align-items-center radius-50',
                  { unFollowBtn: editClicked },
                )}
                onClick={() => {
                  selectHandler();
                }}
                aria-label={editClicked ? 'Delete' : 'Edit'}
                disabled={(editClicked && !removedCompanies.length) || removeClicked}
              >
                {
                  editClicked ? <BinIcon /> : <SelectIcon />
                }
                {isMinWidth ? null : (
                  <span style={{
                    marginLeft: '6px',
                  }}
                  >
                    {getButtonLabel()}
                  </span>
                )}
              </Button>
              {
                editClicked ? (
                  <Button
                    className="tabs-item cancel-btn icon-button icon-mode-tablet d-flex justify-content-center align-items-center radius-50 ml-1"
                    disabled={removeClicked}
                    onClick={() => {
                      setRemovedCompanies([]);
                      setEditClicked(false);
                      dispatch(companiesActions.resetCompareCompaniesIds());
                    }}
                    aria-label="Cancel"
                  >
                    {isMinWidth ? (
                      <Cross />
                    ) : (
                      <span>Cancel</span>
                    )}
                  </Button>
                ) : null
              }
              {
                selectedCompareCompanies.length ? (
                  <Tooltip
                    arrow={false}
                    placement="top"
                    getPopupContainer={(e: HTMLElement) => e}
                    className="triggers-bullet-tooltip btn-tooltip"
                    color="#fff"
                    title="Export selected"
                  >
                    <div className="export-company">
                      <GlobalButton
                        title="Export"
                        textColor="#7E7E7E"
                        bgColor="#fff"
                        outlineColor="#DADADA"
                        innerSpace="9px 15px 9px 15px"
                        PaddingSm="6px 15px"
                        LeftSpace="7px"
                        IconLeft={<ExportIcon />}
                        buttonClassName="share-button mr-24 export_btn"
                        rightSeparatorClassName="right-separator-class"
                        onButtonClick={handleExport}
                        disabled={(editClicked && !removedCompanies.length) || exportLoading}
                      />
                    </div>
                  </Tooltip>
                ) : (
                  <div className="export-company">
                    <GlobalButton
                      title="Export"
                      textColor="#7E7E7E"
                      bgColor="#fff"
                      outlineColor="#DADADA"
                      innerSpace="9px 15px 9px 15px"
                      PaddingSm="6px 15px"
                      LeftSpace="7px"
                      IconLeft={<ExportIcon />}
                      buttonClassName="share-button mr-24 export_btn"
                      rightSeparatorClassName="right-separator-class"
                      onButtonClick={handleExport}
                      disabled={(editClicked && !removedCompanies.length) || exportLoading}
                    />
                  </div>
                )

              }

            </div>
          </div>
        </div>
        <div className="companiesSection">
          <InfiniteScroll
            dataLength={companies?.length}
            next={fetchMoreCompanies}
            hasMore={!companiesEnded}
            loader={loading && getCompaniesLoadingSkeleton()}
            className="o-x-hidden o-y-hidden infinite-for-company-section"
          >
            <Row className="Grid-width-row white-layer-col" gutter={[24, 24]} style={{ margin: '0' }}>
              {
                companies?.length ? (
                  companies.map((company) => (
                    <Col xxl={{ span: 4 }} xl={{ span: 4 }} lg={{ span: 6 }} className="gutter-row list-perf-item">
                      <CompanyCardLarge
                        removeButton={editClicked}
                        removed={removedCompanies.indexOf(company.companyId) !== -1}
                        onCompareSelectionToggle={onCompareSelectionToggle}
                        companyData={company}
                        showDrawerIcon={!!company.companyNotes}
                        showSapIcon={!!company.accountPlanAllowed}
                        isRecomended
                      />
                    </Col>
                  ))
                ) : (
                  null
                )
              }
              {!loading && companies?.length === 0
                && (
                  <Col span={24} className="gutter-row w-100 noSpace">
                    <div className="empty-action-wrapper">
                      <h6 className="heading-no-data">No Result Found</h6>
                      <span className="action-to-global">
                        <span
                          role="button"
                          tabIndex={0}
                          className="clickArea"
                          onClick={goOnGlobalSearch}
                          onKeyPress={goOnGlobalSearch}
                        >
                          Click
                        </span>
                        {' '}
                        to find results from Global Search
                      </span>
                    </div>
                  </Col>
                )}
            </Row>
          </InfiniteScroll>
        </div>
      </div>
    </StyleWrapper>
  );
};

export default CompaniesSection;